import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";
import {
  filedForceApproval,
  filedForceDeniedAccount,
  getSpecificFieldForceAccount,
} from "../../../../redux/features/accounts/fieldForceAccount";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { beneLookUp } from "../../../../redux/features/verifyPAN/verifyPAN";
import { beneBankLookUp } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";

const FieldForceAccountSuccess = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [rejectPopup, setRejectPopup] = useState(false);
  const [declineReason, setDeclineReason] = useState("");

  const services = useSelector((state) => state.refreshToken.services);

  const { getSpecificFieldForceAccountData } = useSelector(
    (state) => state.fieldForceAccount,
  );

  const beneLookData = useSelector((state) => state.verify);

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const accountApproval = () => {
    (async () => {
      toast.dismiss();
      CommonToast({
        text: "Field force account getting approved",
        variant: "var(--processing)",
        icon: ICONS?.LOADER_GIF,
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      let response = await dispatch(filedForceApproval(id));
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Field force account approved",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
          { replace: true },
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.field_force_account[
            GlobalConfiguration.lengthCheckZero
          ],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }
    })();
  };
  const accountRejected = () => {
    (async () => {
      toast.dismiss();
      CommonToast({
        text: "Field force account getting rejected",
        variant: "var(--processing)",
        icon: ICONS?.LOADER_GIF,
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      let response = await dispatch(
        filedForceDeniedAccount({ id, AccountIdData }),
      );
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Field force account rejected",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });

        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
          { replace: true },
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.field_force_account[
            GlobalConfiguration.lengthCheckZero
          ],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
        setRejectPopup(false);
      }
    })();
  };

  const accountData =
    getSpecificFieldForceAccountData?.field_force_accounts?.[0];

  const categories = accountData?.category_ids?.map((category) => {
    return category?.category_name;
  });

  const createAccountHandler = () => {
    navigate("/field_force_account_dashboard/create_field_force_account", {
      replace: true,
    });
  };

  const viewDetailsHandler = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
      { replace: true },
    );
  };

  const dashboardHandler = () => {
    navigate("/field_force_account_dashboard", { replace: true });
  };

  useEffect(() => {
    dispatch(getSpecificFieldForceAccount({ id }));
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [id, dispatch]);

  useEffect(() => {
    if (!accountData) return;

    dispatch(beneLookUp({ pan_number: accountData.pan_no }));

    dispatch(
      beneBankLookUp({
        ifsc: accountData.ifsc_code,
        bank_account_no: accountData.bank_acc_no,
      }),
    );
  }, [accountData, dispatch]);
  const buttonRows = [
    ...(services?.includes("FFAAccount") ||
    (services?.includes("Admin") && accountData?.approval_status === "pending")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              handleFunction: () => {
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              handleFunction: () => {
                accountApproval();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
          ],
        ]
      : []),

    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.CREATE_NEW_ACCOUNT,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },

      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],

    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.GO_TO_DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        imgColor: "var(--text-primary)",
      },
    ],
  ];
  const handleInputChange = (event) => {
    const sanitizedValue = event.target.value
      .replace(/\s+/g, " ")
      .replace(/^\s/, "")
      .slice(0, 150);

    setDeclineReason(sanitizedValue);
  };
  const AccountIdData = declineReason;

  const filteredAccounts = benebankLookData?.beneficiary_accounts?.filter(
    (acc) => {
      const status = acc?.approval_status?.toLowerCase()?.trim();
      return ["pending", "approved"].includes(status);
    },
  );

  return (
    <div>
      {rejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            subtext="Please state the reason for rejecting the account"
            headerFontColor="text-primary"
            headerFontWeight="semibold"
            textSize="font-md"
            inputPlaceholder="Reason(10-150 char)"
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              handleInputChange(e);
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneHandleFunction={() => {
              setRejectPopup(false);
              setDeclineReason("");
            }}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="trans"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              accountRejected();
              setDeclineReason("");
            }}
            btnTwoBtnType="submit"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={
          location?.state?.type === "switch_account"
            ? "Beneficiary account successfully switched to field force account"
            : "Field Force account created successfully and awaiting approval."
        }
      >
        <TabsWeapperSection title="Account details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.name,
                  leftSubTitle: "Account name",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: formatAccountNumber(accountData?.bank_acc_no),
                  leftSubTitle: "Account number",
                  ifsc: accountData?.ifsc_code,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.ifsc_code,
                  leftSubTitle: "IFSC code",
                },
              ]}
            />
            {accountData?.virtual_account === "Y" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle:
                      accountData?.virtual_account_type === "manual"
                        ? "Manually created"
                        : "Auto detected",
                    leftSubTitle: "Virtual account",
                  },
                ]}
              />
            )}

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: categories?.join(","),
                  leftSubTitle: "Categories",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.pan_no,
                  leftSubTitle: "PAN number",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              showRowDivider={true}
              rowBorderColor="var(--positive-bg)"
              rows={[
                {
                  leftTitle: accountData?.field_force_user_full_name,
                  leftSubTitle: "User",
                },
                {
                  leftTitle: accountData?.field_force_identifier,
                  leftSubTitle: "User ID",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.contact_no,
                  leftSubTitle: "Contact number",
                  icon: ICONS?.CONTACT_WITH_WHITE_CIRCLE,
                  iconSize: "small",
                  bgNeeded: false,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.email_id,
                  leftSubTitle: "Email ID",
                  icon: ICONS?.CONTACT_US_MAIL,
                  iconSize: "small",
                  bgNeeded: false,
                  hasLink: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    Array?.isArray(accountData?.labels) &&
                    accountData?.labels?.length >
                      GlobalConfiguration?.lengthCheckZero
                      ? accountData.labels.map((l) => l).join(", ")
                      : "Not assigned",
                  leftSubTitle: "Labels (optional)",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.recipient_email
                    ? accountData?.recipient_email
                    : "Not added",
                  leftSubTitle: "Recipients (optional)",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.id || "NA",
                  leftSubTitle: "Account ID",
                  copyText: accountData?.id || "NA",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
        {beneLookData?.beneLookData?.beneficiary_accounts?.length >
          GlobalConfiguration?.lengthCheckOne && (
          <TabsWeapperSection title="Accounts associated to PAN">
            {beneLookData?.beneLookData?.beneficiary_accounts
              ?.filter(
                (accountData) =>
                  accountData?.approval_status === "pending" ||
                  accountData?.approval_status === "approved",
              )
              .map((accountData, id) => (
                <InfoCard
                  key={id}
                  bgColor="var(--positive-card)"
                  header={true}
                  borderColor="var(--positive-bg)"
                  rightHeaderText={`${
                    accountData?.approval_status?.charAt(0).toUpperCase() +
                    accountData?.approval_status?.slice(1)
                  } account`}
                  rightHeaderTextSize="var(--font-xs)"
                  rightHeaderTextColor="var(--text-secondary)"
                  leftHeaderText={accountData?.bank_account_holder_full_name}
                  leftHeaderWidth="w-width-lg"
                  rows={[
                    {
                      leftTitle: formatAccountNumber(accountData?.bank_acc_no),
                      leftSubTitle: "Bank account number",
                      ifsc: accountData?.ifsc_code,
                    },
                  ]}
                />
              ))}
          </TabsWeapperSection>
        )}

        {Array?.isArray(filteredAccounts) &&
          filteredAccounts.length > GlobalConfiguration?.lengthCheckOne && (
            <TabsWeapperSection title="Accounts associated to Bank">
              {filteredAccounts.map((accountData, id) => (
                <InfoCard
                  key={id}
                  bgColor="var(--positive-card)"
                  header={true}
                  borderColor="var(--positive-bg)"
                  rightHeaderText={`${
                    accountData?.approval_status?.charAt(0).toUpperCase() +
                    accountData?.approval_status?.slice(1)
                  } account`}
                  rightHeaderTextSize="var(--font-xs)"
                  rightHeaderTextColor="var(--text-secondary)"
                  leftHeaderText={accountData?.name}
                  leftHeaderWidth="w-width-lg"
                  rows={[
                    {
                      leftTitle: accountData?.pan_no,
                      leftSubTitle: "PAN number",
                    },
                  ]}
                />
              ))}
            </TabsWeapperSection>
          )}
      </StatusContainer>
    </div>
  );
};

export default FieldForceAccountSuccess;
